// extracted by mini-css-extract-plugin
module.exports = {"review-oparetion-table":"review-oparetion-table-9a0a96d6e89ed42f19a1bdbc9bc47276","refund-money":"refund-money-3d653ca78abf4e4dce28ff745de38c75"};